interface Props {
  eyebrow: string;
  title: string;
  desc?: string;
  extra?: React.ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, extra }: Props) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <div className="flex items-center gap-2">
          <span className="h-4 w-1 rounded-full bg-primary-600" />
          <span className="text-[13px] font-bold uppercase tracking-widest text-primary-600">{eyebrow}</span>
        </div>
        <h3 className="mt-1.5 flex items-center gap-2 font-heading text-2xl font-black text-foreground-950 md:text-[28px]">
          {title}
        </h3>
        {desc && <p className="mt-1 text-[13px] text-foreground-500">{desc}</p>}
      </div>
      {extra}
    </div>
  );
}